import { createActions, handleActions } from 'redux-actions'

export const actionCreators = createActions({
    PANEL: {
        CHANGE: (params) => params,
        DRAWER: {
            SHOW: (params) => params,
            HIDE: (params) => params
        },
        WIND: {
            ADD: (params) => params,
            REMOVE: (params) => params
        },
        LAYER: {
            UPDATE: (params) => params
        },
        VIEWER: (params) => params,
        GROUP: {
            TOGGLE: (params) => params
        },
        VERTEX: {
            ADD: (params) => params,
            CLEAR: (params) => params,
        },
        TEMPERATURE: {
            POINT: (params) => params,
            RESET: (params) => params,
        },
        DRAW: {
            TOGGLE: (params) => params
        },
        OPERATION: {
            VERSION: (params) => params,
            STATUS: (params) => params
        }
    }
});

const reducer = handleActions({
    PANEL: {
        CHANGE: (state, action) => {
            const { name } = action.payload
            return { ...state, name }
        },
        VIEWER: (state, action) => {
            state.viewer = action.payload.value.current.cesiumElement
        },
        DRAWER: {
            SHOW: (state, action) => {
                return { ...state, drawerShow: true }
            },
            HIDE: (state, action) => {
                return { ...state, drawerShow: false }
            }
        },
        LAYER: {
            UPDATE: (state, action) => {
                const { currentLayerGroup, layers } = action.payload
                return { ...state, globe: { [currentLayerGroup]: layers } }
            }
        },
        GROUP: {
            TOGGLE: (state, action) => {
                const { name } = action.payload
                const { globe } = state
                if (name in globe) {
                    return { ...state, globe: {} }
                } else {
                    return { ...state, globe: { [name]: [] } }
                }
            }
        },
        VERTEX: {
            ADD: (state, action) => {
                const { position } = action.payload
                const { vertex } = state
                const length = vertex.length
                return { ...state, vertex: [...(length === 2 ? [] : vertex), position] }
            },
            CLEAR: (state, action) => {
                return { ...state, vertex: [] }
            }
        },
        TEMPERATURE: {
            POINT: (state, action) => {
                const { lng, lat } = action.payload
                return { ...state, temperature: { lng, lat } }
            },
            RESET: (state, action) => {
                return { ...state, temperature: undefined }
            }
        },
        DRAW: {
            TOGGLE: (state, action) => {
                const { drawPolygon } = state
                return { ...state, drawPolygon: !drawPolygon, vertex: [] }
            }
        },
        OPERATION: {
            VERSION: (state, action) => {
                const { operationVersion } = state
                return { ...state, operationVersion: operationVersion + 1 }
            },
            STATUS: (state, action) => {
                const { status } = action.payload
                return { ...state, operationStatus: status }
            },
        }
    }
}, {
    name: 'DATA',
    globe: {},
    drawPolygon: false,
    vertex: [],
    temperature: undefined,
    operationVersion: 0,
    operationStatus: undefined,
    viewer: undefined,
    wind: undefined
});

export default reducer
